export default {
      id: "chevron-left-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#chevron-left",
      toString: function () {
        return this.url;
      }
    }